import TextField from '@mui/material/TextField';
import React from 'react';
import { Controller, FieldPath, FieldValues, UseControllerProps } from 'react-hook-form';

interface ControlledTextFieldProps<T extends FieldValues, TName extends FieldPath<T>>
  extends UseControllerProps<T, TName> {
  label: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  rows?: number;
}

const ControlledTextField = <T extends FieldValues, TName extends FieldPath<T>>({
  label,
  disabled,
  required,
  error,
  helperText,
  rows,
  ...controllerProps
}: ControlledTextFieldProps<T, TName>) => {
  return (
    <Controller
      {...controllerProps}
      render={({ field }) => (
        <TextField
          {...field}
          fullWidth
          multiline
          rows={rows}
          variant='outlined'
          label={label}
          disabled={disabled}
          error={error}
          helperText={helperText}
        />
      )}
    />
  );
};

export default ControlledTextField;
